import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const SAFE_LINK = /^(https?:|mailto:|\/|#)/i;

/**
 * Orla writes her posts in Markdown, and Orla is a model, so the text is untrusted. It is
 * rendered to React elements, never to an HTML string: raw HTML in a post is shown as
 * text, and links that are not web, mail or same-site links lose their destination.
 */
export function PostBody({ markdown }: { markdown: string }) {
  return (
    <div className="post-body">
      <Markdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        urlTransform={(url) => (SAFE_LINK.test(url) ? url : "")}
        components={{
          a: ({ href, children }) =>
            href ? (
              <a href={href} {...(/^https?:/i.test(href) ? { rel: "noopener noreferrer" } : {})}>
                {children}
              </a>
            ) : (
              <span>{children}</span>
            ),
          img: ({ alt }) =>
            alt ? <span className="post-body__image-note">[Image: {alt}]</span> : null,
        }}
      >
        {markdown}
      </Markdown>
    </div>
  );
}
